import { maxNumber } from '../maxNumber/maxNumber';
import { minNumber } from '../minNumber/minNumber';
import type { Error } from '../types';

// TODO: rework
export const numberRange =
  (min: number, max: number, message?: Error['message'], allowEmpty = false) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (value: any): Error => {
    const valid =
      minNumber(min, message, allowEmpty)(value).valid &&
      maxNumber(max, message, allowEmpty)(value).valid;

    return {
      valid: allowEmpty ? isNaN(value) || valid : valid,
      message
    };
  };
